var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupSuccessNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 0C20.384 0 0 20.384 0 45.5C0 70.616 20.384 91 45.5 91C70.616 91 91 70.616 91 45.5C91 20.384 70.616 0 45.5 0ZM37.1071 67.5429C36.7166 67.9334 36.0834 67.9334 35.6929 67.5429L14.3571 46.2071C13.9666 45.8166 13.9666 45.1834 14.3571 44.7929L19.3594 39.7906C19.7495 39.4005 20.3819 39.4 20.7726 39.7896L35.6929 54.6684C36.0836 55.058 36.716 55.0575 37.1061 54.6674L70.2249 21.5486C70.6164 21.1571 71.2515 21.1582 71.6416 21.5511L76.6479 26.5929C77.0361 26.9838 77.0349 27.6151 76.6454 28.0046L37.1071 67.5429Z",
    fill: "url(#paint0_linear_3062_9343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3062_9343",
    x1: 45.5,
    y1: 0,
    x2: 45.5,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DA8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93EDCA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupSuccessNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_success_new_version.b4259313ec074ff0c36a506da1141cdc.svg";
export { ForwardRef as ReactComponent };